import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './api/client';
import { isPlatformAuthenticated } from './api/platformClient';
import { isAffiliateAuthenticated } from './api/affiliateAuth';

export function App() {
  return <Outlet />;
}

export function ProtectedRoute() {
  if (!isAuthenticated()) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function ProtectedPlatformRoute() {
  if (!isPlatformAuthenticated()) return <Navigate to="/platform/login" replace />;
  return <Outlet />;
}

export function ProtectedAffiliateRoute() {
  if (!isAffiliateAuthenticated()) return <Navigate to="/affiliate/login" replace />;
  return <Outlet />;
}

export function RootRedirect() {
  return <Navigate to={isAuthenticated() ? '/dashboard' : '/login'} replace />;
}
